var CustomError = /** @class */ (function () {
    function CustomError(code, message) {
        this.code = code;
        this.message = message;
    }
    return CustomError;
}());
export { CustomError };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3VzdG9tLWVycm9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiY3VzdG9tLWVycm9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0kscUJBQ29CLElBQVksRUFDWixPQUFlO1FBRGYsU0FBSSxHQUFKLElBQUksQ0FBUTtRQUNaLFlBQU8sR0FBUCxPQUFPLENBQVE7SUFDaEMsQ0FBQztJQUNSLGtCQUFDO0FBQUQsQ0FBQyxBQUxELElBS0MifQ==